import type { ReactNode } from 'react';
import { HotkeysProvider } from 'react-hotkeys-hook';

type Props = {
  children: ReactNode;
};

export const SHORTCUT_SCOPES = {
  GLOBAL: 'global',
  CANVAS: 'canvas',
  TABLE: 'table',
  GANTT: 'gantt',
  EDITOR: 'editor',
  DIALOG: 'dialog',
  ELEMENT_SELECTED: 'element-selected'
} as const;

export function ShortcutsProvider({ children }: Props) {
  return <HotkeysProvider initiallyActiveScopes={[SHORTCUT_SCOPES.GLOBAL]}>{children}</HotkeysProvider>;
}
